import { theme } from '@notino/react-styleguide'
import styled from 'styled-components'
import { NotinoBodyLarge, NotinoLabelRegular, NotinoLabelRegular400, NotinoTitleDisplay } from '../../../../styles/helpers'
import { CONTAINER_X_PADDING, SALON_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'

export const TabsContainer = styled.div`
	.rc-tabs {
		display: flex;
		overflow: hidden;
		flex-direction: column;
		margin-left: -${CONTAINER_X_PADDING}px;
		margin-right: -${CONTAINER_X_PADDING}px;
	}
	.rc-tabs-ink-bar {
		display: none;
	}
	.rc-tabs-tabpane-hidden {
		display: none;
	}
	.rc-tabs-nav-operations {
		display: none;
	}
	.rc-tabs-content-holder {
		flex: auto;
		padding-left: ${CONTAINER_X_PADDING}px;
		padding-right: ${CONTAINER_X_PADDING}px;

		.rc-tabs-content {
			position: relative;
			width: 100%;
		}
	}
	.rc-tabs-nav-wrap {
		position: relative;
		flex: auto;
		white-space: nowrap;
		overflow: hidden;
		margin-bottom: 24px;

		&::before {
			position: absolute;
			content: '';
			left: 0;
			right: 0;
			bottom: 0;
			height: 1px;
			background: ${theme.color.background.tertiary};
			z-index: 1;
		}

		.rc-tabs-nav-list {
			display: flex;
			width: 100%;
			gap: 28px;
			overflow-x: auto;
			z-index: 2;
			position: relative;
			padding-left: ${CONTAINER_X_PADDING}px;
			padding-right: ${CONTAINER_X_PADDING}px;

			.rc-tabs-tab {
				border: 0;
				margin: 0;
				display: flex;
				outline: none;
				cursor: pointer;
				position: relative;
				align-items: center;
				white-space: nowrap;
				padding: 8px 0;

				.rc-tabs-tab-btn {
					${NotinoLabelRegular400};
					border: 0;
					background: transparent;
				}

				&.rc-tabs-tab-active {
					.rc-tabs-tab-btn {
						${NotinoLabelRegular};
					}
					&::after {
						position: absolute;
						content: '';
						left: 0;
						right: 0;
						bottom: 0px;
						height: 2px;
						background: ${theme.color.background.inverse};
					}
				}
			}
		}
	}
`

export const OpeningHoursWrapper = styled.section`
	padding-bottom: 16px;
	border-bottom: 1px solid ${theme.color.border.divider};
`

export const ServicesWrapper = styled.section`
	padding-top: 24px;
	border-bottom: 1px solid ${theme.color.border.divider};
`

export const AboutUsWrapper = styled.section`
	padding-top: 24px;
`

export const AboutUsText = styled.p`
	${NotinoBodyLarge};
	white-space: pre-wrap;
	line-height: 1.75rem;
	margin-bottom: 24px;

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		margin-top: 16px;
	}
`

export const ServicesHeading = styled.h2`
	/* resetting global notino margin on heading */
	margin: 0 0 16px;

	${NotinoTitleDisplay};
`

export const Columns = styled.div`
	display: flex;
	align-items: flex-start;
	width: 100%;
	column-gap: 40px;
	margin-bottom: 60px;
`

export const MainColumn = styled.div`
	overflow: hidden; // services tab might oveflow - in that case, we want to scroll services buttons, for which we need overflow on SalonInfo
	flex: 1 1 0;
`

export const SideColumn = styled.aside``

export const ServicesSection = styled.section`
	margin-bottom: 0;
`
